import groupBy from "lodash/groupBy";
import map from "lodash/map";
import pick from "lodash/pick";
import {formatUnit} from 'commons/js/utils/units';
/**
 * Receives an array of objects and returns an array
 * of volumes containing only dimension information
 * @param {array} unfilteredVolumes
 * @returns {array} - the filtered volumes array [{height, width, length, weight}, ...]
 */
export function filterVolumesData(unfilteredVolumes) {
  return map(unfilteredVolumes, volume => pick(volume, ['height', 'width', 'length', 'weight']));
}

/**
 * Receives an array of objects and groups them by
 * dimension information (height, width, length and weight)
 * @param {array} volumes
 * @returns {array} - the grouped array [{height, width, length, weight, times},...]
 */
export function groupVolumes(volumes) {
  const filteredVolumes = filterVolumesData(volumes);

  const grouped = groupBy(filteredVolumes, v => `${v.height}_${v.width}_${v.length}_${v.weight}`);

  return map(grouped, group => ({
    ...group[0],
    times: group.length
  }));
}

/**
 * Receives an object containing dimension keys and
 * returns a string in the format NNxNNxNN cm - NN,NN Kg
 * @param {object} - a object containing height, width, length and weight
 * @returns {string}
 */
export function formatSingleVolumeData({height, width, length, weight}) {
  return `${formatUnit(height)}x${formatUnit(width)}x${formatUnit(length)} cm - ${formatUnit(weight, "kg")}`;
};

/**
* Returns the dimension value with the correct unit of measurement (cm or Kg)
* @param {string} - the label of the field (height, width, length, weight or times)
* @param {string|number} - the value to be formatted
* @returns {string} - the formatted string
*/
export function formatVolumeDimension(label, value) {
  switch (label) {
    case "times":
      return value;
    case "weight":
      return formatUnit(value, 'kg');
    default:
      return formatUnit(value, 'cm');
  }
};
